// @ts-strict-ignore
import { QuickStartCIFile } from './../../../types';
import { selectAuthCredentials } from '../../../selectors/selectors';
import { useSelector } from 'react-redux';
import * as API from '../../../api';
import { RootState } from '../../../reducers/reducers';
import { OpenPRQuickstartResult } from '../../../types';
import { useState } from 'react';

export type OpenPRForQuickStartCIFilesHookData = [
    OpenPRQuickstartResult | undefined,
    boolean,
    Error,
    (files: Pick<QuickStartCIFile, 'fileId'>[]) => Promise<void>,
];

export const useOpenPRForQuickStartCIFiles: (orgId: string, appId: string) => OpenPRForQuickStartCIFilesHookData = (
    orgId,
    appId,
) => {
    const [result, setResult] = useState<OpenPRQuickstartResult | undefined>(undefined);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);
    const authCredentials = useSelector((state: RootState) => selectAuthCredentials(state));

    const startLoading = async (files) => {
        setIsLoading(true);
        setError(undefined);

        try {
            const apiResult = await API.openPRForQuickStartCIFiles({ orgId, appId, files }, authCredentials);
            setResult(apiResult);
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }
    };

    return [result, isLoading, error, startLoading];
};
